import { reducer } from 'redux-clerk2'
//import lodash from 'lodash'
import reduceReducers from 'reduce-reducers'
const mainReducer = reducer({
	actionPrefix: 'RESERVATION_BA_REVIEWS',
});

// Create a reducer to handle any additional actions
const customReducer = (state) => {
	return state;
}

const mainReducers = reduceReducers(mainReducer, customReducer);

export default mainReducers